export interface IAccountOrganizationOutputDto {
    name: string;
    vatNumber: string;
    email: string;
    country: string;
}
